import script from "./Final.vue?vue&type=script&setup=true&lang=js"
export * from "./Final.vue?vue&type=script&setup=true&lang=js"

import "./Final.vue?vue&type=style&index=0&id=0c7f4b10&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7f4b10"]])

export default __exports__